export default __webpack_public_path__ + "static/media/6@3x.d99a854b.png";